import { createSlice } from "@reduxjs/toolkit";
import { loginUserSelectInstitution, logoutUser } from "../actions/account";

const initialState = {
  tableFilters: {},
  columnFilters: [],
  selectedAllLocations: false,
  selectedLocationIds: [],
  unselectedLocationIds: [],
  tabValue: "",
  rowsPerPage: 20
};

const locationUISlice = createSlice({
  name: "locationUI",
  initialState,
  reducers: {
    "account/logoutUser": (state) => initialState,
    storeLocationFilters(state, action) {
      state.tableFilters = action.payload;
    },
    storeLocationColumnFilters(state, action) {
      state.columnFilters = action.payload;
    },
    setSelectedAllLocations(state, action) {
      state.selectedAllLocations = action.payload
    },
    setSelectedLocationIds(state, action) {
      state.selectedLocationIds = action.payload
    },
    setUnselectedLocationIds(state, action) {
      state.unselectedLocationIds = action.payload
    },
    setTabValue(state, action) {
      state.tabValue = action.payload
    },
    setRowsPerPage(state, action) {
      state.rowsPerPage = action.payload
    }
  },
  extraReducers: {
    [logoutUser.fulfilled]: (state) => {
      return initialState;
    },
    [logoutUser.rejected]: (state) => {
      return initialState;
    },
    [loginUserSelectInstitution.fulfilled]: (state) => {
      return initialState;
    },
    [loginUserSelectInstitution.rejected]: (state) => {
      return initialState;
    },
  },
});

export const getTableFilters = (state) => state.locationUI.tableFilters;
export const getColumnFilters = (state) => state.locationUI.columnFilters;
export const getSelectedAllLocations = (state) => state.locationUI.selectedAllLocations;
export const getSelectedLocationIds = (state) => state.locationUI.selectedLocationIds;
export const getUnselectedLocationIds = (state) => state.locationUI.unselectedLocationIds;
export const getTabValue = (state) => state.locationUI.tabValue;
export const getRowsPerPage = (state) => state.locationUI.rowsPerPage;

export const { storeLocationFilters, storeLocationColumnFilters, setSelectedAllLocations, setSelectedLocationIds, setUnselectedLocationIds, setTabValue, setRowsPerPage } = locationUISlice.actions;

export default locationUISlice;
